<template>
  <div v-if=" ModalModify == 1 ">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title> <b> #</b> {{ returnNumberID(stringId) }}</ion-title>
        <ion-buttons slot="end">
          <ion-button class="close-modal" @click="dismissModal(stringId)"> <ion-icon name="close-circle-outline"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <form  name="myFormModal"  >
        <!-- Usuario que solicita  -->
        <ion-item lines="none">
          <p class="w100">
            <b>Solicitante: </b>
            <span class="right-text">{{ datos.UsrSol }}</span>
          </p>
        </ion-item>
        <!-- Usuario contacto  -->
        <ion-item >
          <p class="w100">
            <b>Contacto:</b>
            <span class="right-text"><a href="tel:datos.contacto" > {{ datos.contacto }} </a></span>
          </p>
        </ion-item>
        <!-- deprtamento  -->
        <ion-item lines="none">
          <p class="w100">
            <b> Departmento: </b>
            <span class="right-text">{{ datos.departamento }} </span>
          </p>
        </ion-item>
        <!-- fecha y hora   -->
        <ion-item class="ml-15" lines="none">
          <ion-label> 
            <b> Fecha propuesta </b>
          </ion-label>
          <ion-datetime name="fecha" id="fecha" display-format="DD-MM-YYYY" :value="datos.fecha"   picker-format="DD-MM-YYYY" />  
        </ion-item>
        <ion-item class="ml-15" lines="none">
          <ion-label> 
            <b>  Hora propuesta </b>
          </ion-label>
          <ion-datetime name="hora" id="hora" display-format="h:mm A"  :value="datos.hora" picker-format="h:mm A" />
        </ion-item>
        <!-- Rango de tiempo . . . .   -->
        <ion-item lines="none">
          <p class="w100">
            <b> Duración de la maniobra: </b>
            <span class="right-text">{{ datos.tiempoManiobra }} </span>
          </p>
        </ion-item>
      <!-- Grúa -->
      <ion-item lines="none">
        <ion-label> <b> Grúa </b> </ion-label>
        <ion-select   :value="datos.gruaTipo" name="gruaTipo" ok-text="Aceptar" cancel-text="Cancelar">
          <ion-select-option v-for="u in unidades" :key="u.idd" :value="u.name"  > {{ u.name }} </ion-select-option>
        </ion-select>
      </ion-item>    
        <!-- Responsable en sitio   -->
        <ion-item lines="none">
          <p class="w100">
            <b>Responsable en sitio</b>  
            <span class="right-text">{{ datos.responsable }} </span>
          </p>
        </ion-item>
        <!-- Radio de operacion  -->
        <ion-item lines="none">
          <p class="w100">
            <b>Radio</b>  
            <span class="right-text"> {{ datos.radio }} </span>
          </p>
        </ion-item>
        <!-- Altura   -->
        <ion-item lines="none">
          <p class="w100">
            <b>Altura</b>  
            <span class="right-text"> {{ datos.altura }}  </span>
          </p>
        </ion-item>
        <!--  Peso  de la carga   -->
        <ion-item lines="none">
          <p class="w100">
            <b>Peso</b>  
            <span class="right-text">{{ datos.peso }} </span>
          </p>
        </ion-item>
        <!-- Usuario que solicita  -->
        <ion-item lines="none">
          <p class="w100">
            <strong>  Descripción: </strong>
          </p>
        </ion-item>
        <ion-item>
          <p>
            {{ datos.descripcion }}
          </p>
        </ion-item>
      <!-- campos para add  -->
        <!-- Cliente -->
        <ion-item lines="none">
          <ion-label position="floating">Cliente</ion-label>
          <ion-input name="cliente" :value="datos.cliente" ></ion-input>
        </ion-item>
        <!-- Encargado de la Obra -->
        <ion-item lines="none">
          <ion-label position="floating">  Encargado de la obra <ion-text color="danger">*</ion-text> </ion-label>
          <ion-input name="Encargado_Obra"></ion-input>
        </ion-item>
        <!-- Operador -->
        <ion-item lines="none">
          <ion-label> <b> Operador </b> </ion-label>
          <ion-select name="Operador" interface="action-sheet"  cancel-text="Cancelar">
            <!-- <ion-select-option value="Gutierrez Rodriguez Carlos Eligio" > Gutierrez Rodriguez Carlos Eligio </ion-select-option> -->
            <ion-select-option  v-for="o in operadores" :key="o.id" :value="o.name" > {{o.name}} </ion-select-option>
          </ion-select>
        </ion-item> 

        <!-- Ayudante -->
        <ion-item lines="none">
          <ion-label> <b> Ayudante </b> </ion-label>
          <ion-select  name="Ayudante" interface="action-sheet" cancel-text="Cancelar">
            <!-- <ion-select-option value="Gutierrez Rodriguez Carlos Eligio"> Gutierrez Rodriguez Carlos Eligio </ion-select-option> -->
            <ion-select-option  v-for="o in operadores" :key="o.id" :value="o.name" > {{o.name}} </ion-select-option>
          </ion-select>
        </ion-item> 
        <!-- Unidad -->
        <!-- <ion-item lines="none">
          <ion-label> <b> Unidad </b> </ion-label>
          <ion-select  name="Unidad" ok-text="Aceptar" cancel-text="Cancelar">
            <ion-select-option value="900"> 900 </ion-select-option>
            <ion-select-option value="901"> 901 </ion-select-option>
            <ion-select-option value="903"> 903 </ion-select-option>
            <ion-select-option value="904"> 904 </ion-select-option>
            <ion-select-option value="905"> 905 </ion-select-option>
            <ion-select-option value="906"> 906 </ion-select-option>
            <ion-select-option value="907"> 907 </ion-select-option>
            <ion-select-option value="908"> 908 </ion-select-option>
            <ion-select-option value="909"> 909 </ion-select-option>
            <ion-select-option value="910"> 910 </ion-select-option>
            <ion-select-option value="911"> 911 </ion-select-option>
            <ion-select-option value="913"> 913 </ion-select-option>
            <ion-select-option value="914"> 914 </ion-select-option>
            <ion-select-option value="915"> 915 </ion-select-option>
            <ion-select-option value="Camion 36"> Camion 36 </ion-select-option>
            <ion-select-option value="Camion 39"> Camion 39 </ion-select-option>
            <ion-select-option value="Camion 49"> Camion 49 </ion-select-option>
            <ion-select-option value="Camion 146"> Camion 146 </ion-select-option>
            <ion-select-option value="GRUA 916"> GRUA 916 </ion-select-option>
            <ion-select-option value="CAMION 100"> CAMION 100 </ion-select-option>
          </ion-select>
        </ion-item>  -->
        
        <!-- Costo de traslado -->
        <ion-item lines="none">
          <ion-label position="floating">Costo por hora</ion-label>
          <ion-input name="costoHora" ></ion-input>
        </ion-item>

        <!-- Costo por hora -->
        <ion-item lines="none">
          <ion-label position="floating">Costo de traslado</ion-label>
          <ion-input name="costoTraslado" ></ion-input>
        </ion-item>

        <!-- Costo por hora extra-->
        <ion-item lines="none">
          <ion-label position="floating">Costo por hora extra</ion-label>
          <ion-input name="costoHoraExtra" ></ion-input>
        </ion-item>

        <!-- Costo por total-->
         <ion-item lines="none">
          <ion-label position="floating">Costo total del servicio</ion-label>
          <ion-input name="costoTotal" ></ion-input>
        </ion-item>

      </form>
      <!-- Usuario que genero -->
      <ion-item lines="none">
        <p class="w100">
          <b>Persona que realizo</b>  <br/><br/>
          <span class="">{{ usrGenerico }} </span>
        </p>
      </ion-item>
      <ion-row>
        <ion-col>
          <ion-button expand="full" color="light" @click="dismissModal()" >
            Cancelar
          </ion-button>
        </ion-col>

        <ion-col>
          <ion-button expand="full" @click="modifyAlterSet(stringId)" >Guardar</ion-button>
        </ion-col>
      </ion-row>
            
    </ion-content>
  </div>
  <div v-else-if=" ModalModify == 2 ">
    <ion-header translucent>
      <ion-toolbar>
        <ion-title> <b> #</b> {{ returnNumberID(stringId) }}</ion-title>
        <ion-buttons slot="end">
          <ion-button class="close-modal" @click="dismissModal(stringId)"> <ion-icon name="close-circle-outline"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
        <!-- Usuario que solicita  -->
        <ion-item lines="none">
          <p class="w100">
            <b>Solicitante: </b>
            <span class="right-text">{{ datos.UsrSol }}</span>
          </p>
        </ion-item>
        <!-- Usuario contacto  -->
        <ion-item >
          <p class="w100">
            <b>Contacto:</b>
            <span class="right-text"><a href="tel:datos.contacto" > {{ datos.contacto }} </a></span>
          </p>
        </ion-item>
        <!-- deprtamento  -->
        <ion-item lines="none">
          <p class="w100">
            <b> Departmento: </b>
            <span class="right-text">{{ datos.departamento }} </span>
          </p>
        </ion-item>
        <!-- fecha y hora   -->
        <ion-item lines="none">
          <p class="w100">
            <b> Fecha: </b>
            <span class="right-text">{{ getDateFormat(datos.fecha,"D") }} </span>
          </p>
        </ion-item>

        <!-- fecha y hora   -->
        <ion-item lines="none">
          <p class="w100">
            <b> Hora: </b>
            <span class="right-text">{{ getDateFormat(datos.hora, "H") }} </span>
          </p>
        </ion-item>

        <!-- Grua  -->
        <ion-item lines="none">
          <p class="w100">
            <b> Grúa: </b>
            <span class="right-text">{{ datos.gruaTipo }} </span>
          </p>
        </ion-item>

        <!-- Responsable en sitio   -->
        <ion-item lines="none">
          <p class="w100">
            <b>Responsable en sitio</b>  
            <span class="right-text">{{ datos.responsable }} </span>
          </p>
        </ion-item>
        <!-- Radio de operacion  -->
        <ion-item lines="none">
          <p class="w100">
            <b>Radio</b>  
            <span class="right-text"> {{ datos.radio }} </span>
          </p>
        </ion-item>
        <!-- Altura   -->
        <ion-item lines="none">
          <p class="w100">
            <b>Altura</b>  
            <span class="right-text"> {{ datos.altura }}  </span>
          </p>
        </ion-item>
        <!--  Peso  de la carga   -->
        <ion-item lines="none">
          <p class="w100">
            <b>Peso</b>  
            <span class="right-text">{{ datos.peso }} </span>
          </p>
        </ion-item>
        <!-- Usuario que solicita  -->
        <ion-item lines="none">
          <p class="w100">
            <strong>  Descripción: </strong>
          </p>
        </ion-item>
        <ion-item>
          <p>
            {{ datos.descripcion }}
          </p>
        </ion-item>
      <!-- campos para add  -->
        <!-- Cliente  -->
        <ion-item lines="none">
          <p class="w100">
            <b> Cliente: </b>
            <span class="right-text">{{ datos.cliente }} </span>
          </p>
        </ion-item>
        <!-- Encargado de la Obra -->
        <ion-item lines="none">
          <p class="w100">
            <b> Encargado de la obra : </b>
            <span class="right-text">{{ datos.responsableSitio }} </span>
          </p>
        </ion-item>


        <!-- Operador -->
        <ion-item lines="none">
          <p class="w100">
            <b> Operador : </b>
          <span class="right-text">{{ datos.Operador }} </span>
          </p>
        </ion-item>

        <!-- Ayudante -->
         <ion-item lines="none">
          <p class="w100">
            <b> Ayudante : </b>
            <span class="right-text">{{ datos.Ayudante }} </span>
          </p>
        </ion-item>

        <!-- Unidad -->
         <ion-item lines="none">
          <p class="w100">
            <b> Unidad : </b>
            <span class="right-text">{{ datos.Unidad }} </span>
          </p>
        </ion-item>

        <!-- Costo por hora -->
         <ion-item lines="none">
          <p class="w100">
            <b> Costo por hora : </b>
            <span class="right-text">{{ datos.costoHora }} </span>
          </p>
        </ion-item>

        <!-- Costo de traslado -->
         <ion-item lines="none">
          <p class="w100">
            <b> Costo de traslado:  </b>
            <span class="right-text">{{ datos.costoTraslado }} </span>
          </p>
        </ion-item>

        <!-- Costo por total-->
         <ion-item lines="none">
          <p class="w100">
            <b> Costo por hora extra : </b>
            <span class="right-text">{{ datos.costoTotal }} </span>
          </p>
        </ion-item>

        <!-- Costo por hora extra-->
         <ion-item lines="none">
          <p class="w100">
            <b> Costo total del servicio : </b>
            <span class="right-text">{{ datos.costoHoraExtra }} </span>
          </p>
        </ion-item>
      <ion-item-divider>
      </ion-item-divider>
      <!-- Usuario que genero -->
      <ion-item lines="none">
        <p class="w100"> <b>Persona que realizo requisición:</b> </p>
        <p class="w100"> {{ usrGenerico }} </p>
      </ion-item>

      <!-- OT -->
      <ion-item lines="none">
        <p> <b> OT asignada: </b> &nbsp; &nbsp; </p>
        <ion-input id="ot-asig" required placeholder="#OT1234" name="OT" /> 
      </ion-item>
      
      <ion-row>
        <ion-col>
          <ion-button expand="full" color="light" @click="dismissModal()" >
            Cancelar
          </ion-button>
        </ion-col>

        <ion-col>
          <ion-button expand="full" @click="modifyAlterSet(stringId)" >Guardar</ion-button>
        </ion-col>
      </ion-row>
            
    </ion-content>
  </div>
  <div v-else>
    <!-- . . . . ReadView MODAL en USUARIO  . . . . -->

  </div>
</template>

<script>
import axios from 'axios';
import firebase from '../config'
import {func} from '../func.js'
const { db } = firebase;
let dt = require('dateformat');
export default {
  name: 'Modal',
  props: {
    title: { type: String, default: ' - - -' },
    ModalModify: { type: Number, default:0}
  },
  firestore: {
    // solicitudesDisponibles: db.collection('todos'),
  },
  data() {
    return {
      isSaved:0,
      content: 'Content',
      datos:{},
      usrGenerico:"Caleb Martinez",
      
      solicitudesDisponibles:[],
      stringId:"",
      unidades:[],
      operadores:[],
    }
  },
  methods: {
    getOpAndAyudamtes(){
      let _self = this;
      let _operadores = [];
      db.collection('/operadores_ayudantes')
      .where("activo","==", true)
      .get()
      .then(function(result) {
        result.forEach(function(doc) {
        //
        let tmp_data = doc.data(); 
        tmp_data.idd = doc.id;
        _operadores.push(tmp_data);
        });
        _self.operadores = _operadores;
      })
      .catch( err => console.log("Err get unidades => ",  err) )
    },
    getUnidades(){
      let _self = this;
      let _unidades = [];
      db.collection('unidades')
      .where("activo","==", true)
      .orderBy('name')
      .get()
      .then(function(result) {
        result.forEach(function(doc) {
        //
        let tmp_data = doc.data(); 
        tmp_data.idd = doc.id;
        _unidades.push(tmp_data);
        });
        _self.unidades = _unidades;
      })
      .catch( err => console.log("Err get unidades => ",  err) )
    },
    getDateFormat($d,$f) {
      let now = new Date($d);
      let f = ($f == "D") ? dt(now, "yyyy, mmmm d"): dt(now, "h:MM TT") ;
      return f;
    },
    returnNumberID(_string){
      return func.returnID(_string);
    },
    dismissModal() {
      // this.modifyAlterSet();
      // if( this.isSaved ){ window.location.href = "/solicitudes" ; return; }
      document.querySelector("ion-modal").dismiss();
    },

    modifyAlterSet() {
      let _self = this;
      let $_id = this.stringId;
      let _datos = {};
      if( _self.ModalModify == 1){
        let myForm = document.querySelector('form');
        for (let i = 0; i < myForm.length; i++) {
          if( myForm[i].value == ""  ){
            alert("El campo: "+ myForm[i].name + ", no puede estar vacío");
            return false; 
          }
          _datos[myForm[i].name] =  myForm[i].value;
        }
        // let arr = ["En revsión",4,"leída"];
        let arr = ["En revsión",3,"Modificada"];
        if (  window.localStorage.getItem('messagingToken') != null ){
          _datos.OpToken =  window.localStorage.getItem('messagingToken');
        }
        _datos.genero = this.usrGenerico;
        _datos.status = arr;
        // _datos.OT 
        _datos.revisionOP = true;
      }
      if( _self.ModalModify == 2 ){
        let arr = ["Modificada",4,"OT asignada"];
        let OT = document.querySelector("#ot-asig").value
        _datos.status = arr;
        _datos.OT = OT; 
        if( OT == "" ){
          alert(" La Orden de trabajo no puede estar vacia.");
          return;
        }
        if (  window.localStorage.getItem('messagingToken') != null ){
          _datos.ADMSToken =  window.localStorage.getItem('messagingToken');
        }        
        _datos.asignacionOt = true; 
      }
      _self.isSaved = 1;
      // return;
      // console.log(this.$firebaseRefs);return;
      let token = _self.datos.token;
      // let solicitud = _self.stringId.substring(0,5);
      let solicitud = _self.returnNumberID(_self.stringId);
      let ubicacion = ( _self.ModalModify == 1 ) ? "OP" : "ADMS";
      db.collection('todos').doc($_id).update(_datos)
      .then ( () => {
        let _ddd =  _datos;
        _ddd.deal  = (_self.datos.deal != undefined)?_self.datos.deal : false ;
        if(_self.ModalModify == 1){
          _ddd.hora_string = _self.getDateFormat(_datos.hora,"H");
        }
        _ddd.solicitud = _self.stringId;
        if(_ddd.deal)
          _self.notifyHubSpot(_ddd);
        if( token != null ){
          axios.post(`https://us-central1-mi-test-b974c.cloudfunctions.net/SendMessage`,{ "token": token, "solicitud": solicitud, "ubicacion": ubicacion  })
            .then( r => {
              console.log("Notificacion enviada con exito", r)
            })
            .catch( error => { console.log("Se presento un error durante el envio de la notificacion ", error);_self.dismissModal(); } )
        }else{
          _self.dismissModal();
          // NO CONTAMOS CON UN TOKEN PARA LA NOTIFICACION  . . . . .
        }
        _self.dismissModal();
      });
    },
    saveTokenActualUsr(){
      // let soli = this.stringId;
      let soli = this.returnNumberID(this.stringId);
      let ubicacion = ( this.ModalModify == 1 ) ? "OP" : "ADMS";
      let actualToken = window.localStorage.getItem('messagingToken');
      let data = { "token":actualToken, "solicitud": soli, "ubicacion" : ubicacion  };
      console.log(data);
      if(actualToken != null ){
        axios.post(`https://us-central1-mi-test-b974c.cloudfunctions.net/SendNotification`, data)
        .then( r => console.log("Save token and notification: ", r))
        .catch( error => console.log("Not seve profile notification: ", error) )
      }
    },
    notifyHubSpot($d){
      // # (_self.MOdalModify == 2 ))
      let _url = (this.ModalModify == 1) ? `https://us-central1-mi-test-b974c.cloudfunctions.net/saveHubSpotOP`: `https://us-central1-mi-test-b974c.cloudfunctions.net/saveHubSpotADMS`;
      console.log("DDDD: ", $d);
      // let _url = "https://api.hubapi.com/deals/v1/deal?hapikey01cd2c9e-7d32-4605-985a-30b129d3e8cc"; saveHubSpot
      axios.post(_url,$d)
      .then((result) => {
        console.log(result)
      }).catch((err) => {
        console.log(err)
      });
    },
  },
  created(){
    let _self = this;
    let _info = _self.$storage.get("user-info");
    _self.usrGenerico = _info.name;
    _self.getUnidades();
    _self.getOpAndAyudamtes();
  }
}
</script>
<style lang="scss" scoped>
  .close-modal{font-size:20px;}
  .center{text-align: center;}
  .m5{
    margin-top:5px; 
    margin-bottom:5px; 
  }
  p{
    &.w100{
      width: 100%;
    }
  }
  span{
    &.right-text{
      float:right;
      
    }
  }
  .action-sheet-selected.sc-ion-action-sheet-md {
      font-weight: 900;
      color: #630b0b;
  }
  div.action-sheet-group.action-sheet-group-cancel.sc-ion-action-sheet-md > button > span{
    font-size: 1.4em !important;
    font-weight: 700 !important;
  }
  div.action-sheet-group.action-sheet-group-cancel.sc-ion-action-sheet-md > button{background: #ecb4b4 !important;}
  .action-sheet-cancel{
    /* right: 0px; */
    background: #ecb4b4 !important;
  }
  button.action-sheet-group action-sheet-group-cancel sc-ion-action-sheet-md{
    background: #ecb4b4 !important;
  }
</style>